"use client";

import styles from "./banner.module.scss";
import Image from "next/image";

function Banner() {
  return (
    <>
      <section className={styles.titleContainer}>
        <h1 className={styles.title}>
          <Image
            src="/logos/peatsense-logo-beta.png"
            priority
            width="0"
            height="0"
            sizes="100vw"
            alt="PeatSense Logo"
          />
          PeatSense
        </h1>
      </section>
    </>
  );
}

export default Banner;
